/* eslint-disable custom/no-hex-colors */
const COMMON_COLORS = {
  'black': '#000000',
  'white': '#FFFFFF',
  'blue1LightMode': '#E7EDF3',
  'blue1DarkDarkMode': '#192530',
  'blue5': '#2B73AB',
  'blue6': '#1A466B',
  'gray0': '#FFFFFF',
  'gray2': '#F1F3F5',
  'gray4': '#CFD4DA',
  'gray5': '#ADB5BD',
  'gray6': '#818A92',
  'gray7': '#697077',
  'gray8': '#485056',
  'gray9': '#343A40',
  'gray10': '#21242A',
};

const CUSTOM_UI_VARS = {
  'text-color': COMMON_COLORS['gray9'],
  'primary-button-hover': COMMON_COLORS['blue6'],
};

const BASIC_PALETTE = [
  '#F1A099',
  '#FFC67B',
  '#FFE6A2',
  '#80E5B1',
  '#92E8E8',
  '#A6A1E6',
  '#E2A1E6',
  '#E44234', // red for signature modals
  '#FF8D00',
  '#FFCD45',
  '#00CC63',
  '#25D2D1',
  '#4E7DE9', // blue for signature modals
  '#C544CE',
  '#88271F',
  '#B54800',
  '#F69A00',
  '#007A3B',
  '#167E7D',
  '#2E4B8B',
  '#76287B',
  '#FFFFFF',
  '#CDCDCD',
  '#9C9C9C',
  '#696969',
  '#272727',
  '#000000',
  'transparency',
];

/* eslint-enable custom/no-hex-colors */
export {
  COMMON_COLORS,
  CUSTOM_UI_VARS,
  BASIC_PALETTE,
};
